const hoursAmPm: {
  hours: string;
}[] = [
  {
    hours: "12:00 am",
  },
  {
    hours: "01:00 am",
  },
  {
    hours: "02:00 am",
  },
  {
    hours: "03:00 am",
  },
  {
    hours: "04:00 am",
  },
  {
    hours: "05:00 am",
  },
  {
    hours: "06:00 am",
  },
  {
    hours: "07:00 am",
  },
  {
    hours: "08:00 am",
  },
  {
    hours: "09:00 am",
  },
  {
    hours: "10:00 am",
  },
  {
    hours: "11:00 am",
  },
  {
    hours: "12:00 pm",
  },
  {
    hours: "01:00 pm",
  },
  {
    hours: "02:00 pm",
  },
  {
    hours: "03:00 pm",
  },
  {
    hours: "04:00 pm",
  },
  {
    hours: "05:00 pm",
  },
  {
    hours: "06:00 pm",
  },
  {
    hours: "07:00 pm",
  },
  {
    hours: "08:00 pm",
  },
  {
    hours: "09:00 pm",
  },
  {
    hours: "10:00 pm",
  },
  {
    hours: "11:00 pm",
  },
];

const hours24: {
  hours: string;
}[] = [
  {
    hours: "00:00",
  },
  {
    hours: "01:00",
  },
  {
    hours: "02:00",
  },
  {
    hours: "03:00",
  },
  {
    hours: "04:00",
  },
  {
    hours: "05:00",
  },
  {
    hours: "06:00",
  },
  {
    hours: "07:00",
  },
  {
    hours: "08:00",
  },
  {
    hours: "09:00",
  },
  {
    hours: "10:00",
  },
  {
    hours: "11:00",
  },
  {
    hours: "12:00",
  },
  {
    hours: "13:00",
  },
  {
    hours: "14:00",
  },
  {
    hours: "15:00",
  },
  {
    hours: "16:00",
  },
  {
    hours: "17:00",
  },
  {
    hours: "18:00",
  },
  {
    hours: "19:00",
  },
  {
    hours: "20:00",
  },
  {
    hours: "21:00",
  },
  {
    hours: "22:00",
  },
  {
    hours: "23:00",
  },
  {
    hours: "00:00",
  },
];
export { hoursAmPm, hours24 };
